import axios from "axios";

export async function getUserAppliedJobs(candidateID) {
	return axios
		.get(`/api/JobDetails/UserAppliedJobs?candidateID=${candidateID}`)
		.then((res) => res?.data?.data?.applied_jobs);
}
